import React from 'react';
import { Dropdown } from 'semantic-ui-react';

const CountryDropdown = ({
    options,
    name,
    placeholder,
    fluid,
    selection,
    onBlur,
    onChange,
    value,
    defaultValue,
    className,
    search,
    clearable = false,
    loading = false,
    scrolling = false
}) => {
    // Transform options - keep text as plain string for search functionality
    // Semantic UI Dropdown will automatically display flags if flag property exists
    const transformedOptions = options.map(option => ({
        ...option,
        // Ensure text is a plain string (not JSX) for search to work
        text: typeof option.text === 'string' ? option.text : String(option.text)
    }));

    return (
        <Dropdown
            name={name}
            search={search}
            clearable={clearable}
            scrolling={scrolling}
            placeholder={placeholder}
            className={className}
            fluid={fluid}
            selection={selection}
            options={transformedOptions}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            loading={loading}
            defaultValue={defaultValue}
        />
    );
};

export default CountryDropdown; 